import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useApi} from "../../../../providers/ApiProvider";
import ProjectsRequests from "../../../../requests/ProjectsRequests";
import {useNotifications} from "../../../../providers/NotificationsProvider";
import {useAuth} from "../../../../providers/AuthProvider";


export default function MapInfoPanel({project, type, children, onValueChange, canEdit = false}) {
    const {projectId} = useParams();
    const apiContext = useApi();
    const {user} = useAuth();
    const projectsRequests = new ProjectsRequests(apiContext.api);
    const notifications = useNotifications();

    const [loading, setLoading] = React.useState(false);
    const [editMode, setEditMode] = React.useState(false);
    const [canEditTitle, setCanEditTitle] = React.useState(false);
    const [value, setValue] = React.useState(project[type]);
    const [projectStatus, setProjectStatus] = useState(project.status ? project.status : '30_cancelled');


    useEffect(() => {
        if (project.status) {
            setProjectStatus(project.status);
        }
    }, [project.status]);


    useEffect(() => {
        let newLevel = false;

        if (user && ((project.user_id === user.id) || user.type === 'admin')) {
            newLevel = true;
        }

        setCanEditTitle(newLevel);
    }, [project]);


    useEffect(() => {
        setValue(project[type]);
    }, [project[type]]);


    const updateValue = (e) => {
        setValue(e.target.value);
    }


    const save = () => {
        setLoading(true);
        projectsRequests.update(projectId, {[type]: value}).then(() => {
            notifications.notify('Project updated!', 'success');
        }).finally(() => {
            onValueChange(value);
            setEditMode(false);
            setLoading(false);
        });
    }


    return (<>
        {editMode && canEdit ? (<>
            <input type="text" className="form-control map-info-control" value={value} onChange={updateValue} onKeyDown={(e) => {
                // check if enter key is pressed
                if (e.keyCode === 13) {
                    save();
                }
            }} />
            <button className="icon-button d-flex" onClick={save}><i className={loading ? 'spinner-border spinner-border-sm' : 'ti ti-device-floppy fs-4'}></i></button>
        </>) : (<>
            {children}
            {canEditTitle ? (
            <button className={'icon-button'+(projectStatus !== '00_in_progress' ? ' d-none' : '')} onClick={() => {setEditMode(true)}}><i className="ti ti-pencil fs-4"></i></button>
            ) : null}
        </>)}
    </>);
}